import React, { useEffect, useState } from "react";
import HttpClient from "../utils/HttpClient";

const AdvancedSearchBox = ({ closemodal, searchFilter, initialData, result, text }) => {
  const [selectedOption, setSelectedOption] = useState(initialData?.businessStatus || "all");
  const [country, setCountry] = useState([])
  const [filterKey, setFilterKey] = useState(initialData);
  const [countryStates, setCountryStates] = useState([]);
  const [companyServices, setCompanyServices] = useState([]);

  const handleInsertData = (key, value) => {
    setFilterKey({ ...filterKey, [key]: value });
  };

  const handleSearch = async () => {
    searchFilter(filterKey);
    let data = {
      ...filterKey,
      searchName: text,
      page: 1,
      limit: 20
    };
    search(data);
    closemodal()
  };

  const search = async (data) => {
    const response = await HttpClient.requestData( "search-business", "POST", data);
    if (response?.status) {
      result(response)
    } else {
      console.log("Error while fetching the data ");
    }
  };

  const getCountryStates = async (id) => {
    try {
      const res = await HttpClient.requestData(
        `countrywise-state/${id}`,
        "GET"
      );
      if (res?.status) {
        setCountryStates(res.data?.[0]?.states || []);
      }
    } catch (error) {
      console.error("Error fetching country states:", error);
    }
  };

  const getTypeOfBusiness = async () => {
    try {
      const response = await HttpClient.requestData("companyType", "GET");
      if (response.status) {
        setCompanyServices(response.data);
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  useEffect(() => {
     setFilterKey({ ...filterKey, ['businessStatus']: selectedOption });
  }, [selectedOption])

  const getCountry = async () => {
    const res = await HttpClient.requestData("countries", "GET", {});
    if (res && res?.status) {
      setCountry(res?.data);
    }
  }

  useEffect(() => {
    getCountryStates(filterKey.country);
  }, [filterKey.country]);

  useEffect(() => {
    // getCompanyTypeWiseServices()
    getTypeOfBusiness()
    getCountry()
    // getCountryStates()
  }, [])

  return (
    <div className="uploabannermodalbgshadow ">
      <div className="owenoagedjeywordbgmain">
        <div className="crossdivmainmnm" onClick={() => closemodal()} style={{cursor:"pointer"}}>
          <i className="fa-solid fa-xmark"></i>
        </div>

        <div className="keywirdrserchttxtdibgflxmain">
          <div className="keywirdrserchttxtdibgflx">
            <div className="keywirdrserchdibvnain">
              <p className="keywirdrserchdibvnainttxpp">Keyword</p>
            </div>
            <div className="keywirdrserchdibinpiuytxtdiv">
              <input
                type="text"
                value={filterKey?.product}
                onChange={(e) => handleInsertData("product", e.target.value)}
                className="keywprodsecrtinputmain"
                placeholder="Enter keyword"
              />
            </div>
          </div>

          <div className="keywirdrserchttxtdibgflx">
            <div className="keywirdrserchdibvnain">
              <p className="keywirdrserchdibvnainttxpp">Category</p>
            </div>
            <select className="neooSelect"
              // value={filterKey?.productCat}
              onClick={(e) => {
                handleInsertData("productCat", e.target.value)
              }}
              style={{
                height: "44px",
                padding: "5px 10px 5px 20px",
                fontSize: "15px"
              }}
            >
              <option value="">Choose...</option>
              {
                companyServices
                  .map((item, key) => {
                    return (
                      <><option key={key} value={item?.type} selected={filterKey.productCat == item?.type}>{item?.type}</option></>
                    )
                  })
              }
            </select>
          </div>

          <div className="keywirdrserchttxtdibgflx">
            <div className="keywirdrserchdibvnain">
              <p className="keywirdrserchdibvnainttxpp">Page</p>
            </div>

            <div className="keywirdrserchdibinpiuytxtdiv">
              <div className="">
                <div className="chekowcutbnemttxndivflx">
                  <input
                    type="checkbox"
                    className="chekowcutomedesign"
                    checked={selectedOption === "all"}
                    onChange={() => setSelectedOption("all")}
                  />
                  <label className="labbnemttxptt">All</label>
                </div>

                <div className="chekowcutbnemttxndivflx">
                  <input
                    type="checkbox"
                    className="chekowcutomedesign"
                    checked={selectedOption === "premium"}
                    onChange={() => setSelectedOption("premium")}
                  />
                  <label className="labbnemttxptt">Premium Members</label>
                </div>

                <div className="chekowcutbnemttxndivflx">
                  <input
                    type="checkbox"
                    className="chekowcutomedesign"
                    checked={selectedOption === "verified"}
                    onChange={() => setSelectedOption("verified")}
                  />
                  <label className="labbnemttxptt">Verified list</label>
                </div>
              </div>
            </div>
          </div>

          <div className="keywirdrserchttxtdibgflx">
            <div className="keywirdrserchdibvnain">
              <p className="keywirdrserchdibvnainttxpp">Location</p>
            </div>
            <div className="keywirdrserchdibinpiuytxtdiv">
              <input
                type="text"
                value={filterKey?.location}
                onChange={(e) =>
                  setFilterKey({ ...filterKey, location: e.target.value })
                }
                className="keywprodsecrtinputmain"
                placeholder="Enter address"
              />
            </div>
          </div>

          <div className="keywirdrserchttxtdibgflx">
            <div className="keywirdrserchdibvnain">
              <p className="keywirdrserchdibvnainttxpp">Country</p>
            </div>

            <select className="neooSelect"
              // value={filterKey?.country}
              onClick={(e) => {
                handleInsertData("country", e.target.value)
              }}
              style={{
                height: "44px",
                padding: "5px 10px 5px 20px",
                fontSize: "15px"
              }}
            >
              <option value="">Choose...</option>
              {
                country
                  .map((item, key) => {
                    return (
                      <><option key={key} value={item?._id} selected={filterKey.country == item?._id}>{item?.name}</option></>
                    )
                  })
              }
            </select>
          </div>

          <div className="keywirdrserchttxtdibgflx">
            <div className="keywirdrserchdibvnain">
              <p className="keywirdrserchdibvnainttxpp">State</p>
            </div>

            <select className="neooSelect"
              name="emirate"
              value={filterKey.emirate}
              onChange={(e) =>
                handleInsertData("state", e.target.value)
              }
              style={{
                height: "44px",
                padding: "5px 10px 5px 20px",
                fontSize: "15px"
              }}
            >
              <option value="">Choose...</option>
              {
                countryStates?.map((item) => {
                  return (
                    <><option key={item?._id} value={item.name} selected={filterKey.state == item?.name}>{item.name}</option></>
                  )
                })
              }
            </select>
          </div>

          <div className="cancelbscearchbtntndiv">
            <button className="cancelbtn"
              onClick={() => {
                setFilterKey(initialData)
                // setViewAll(true)
                // setViewPremiumMembers(false)
                // setViewVerifiedList(false)
                setSelectedOption("all")
                closemodal()
              }}
            >Cancel</button>
            <button className="scearchbtn" onClick={handleSearch}>Search</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvancedSearchBox;
